import type { WasmFinder } from 'tzf-wasm';
import timezoneDataUrl from 'tzf-wasm/tzf_wasm_bg.wasm';

let finderPromise: Promise<WasmFinder> | undefined;

// Load the bundled boundary data once, shared by the badge, form and save check.
// Failed loads are not cached so Retry can recover after a connection failure.
export const loadTimezoneFinder = () => {
  if (!finderPromise) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    finderPromise = Promise.all([
      import('tzf-wasm'),
      fetch(timezoneDataUrl, {
        signal: controller.signal,
        credentials: 'omit',
      }),
    ])
      .then(async ([{ default: initialize, WasmFinder }, response]) => {
        if (!response.ok) throw new Error('Could not load timezone data');
        await initialize({ module_or_path: await response.arrayBuffer() });
        return new WasmFinder();
      })
      .catch((error: unknown) => {
        finderPromise = undefined;
        throw error;
      })
      .finally(() => clearTimeout(timeout));
  }
  return finderPromise;
};
